import {gsap} from "../LibrariesImport";
import {GlobalVariables} from "../GlobalVariables";

export default class BannerNews {
    constructor() {
        this.bannerNewsContainer = document.querySelector(".banner-home");

        if (!this.bannerNewsContainer) {
            return;
        }

        const mm = gsap.matchMedia();
        mm.add("(max-width: 990px)", () => {
            document.querySelectorAll("[data-mobile-class]").forEach(elem => {
                elem.setAttribute("class", elem.dataset.mobileClass);
                elem.style.cssText = null;
            });

            const newsSwiper = this.bannerNewsContainer.querySelector(".swiper");
            const swiper = new Swiper(newsSwiper, {
                slidesPerView: "auto",
                grabCursor: true,
                // autoHeight: false,
                spaceBetween: 10
            });

            return () => {
                swiper.destroy(true, true);
            };
        });

        mm.add("(min-width: 991px)", () => {
            document.querySelectorAll("[data-desktop-class]").forEach(elem => {
                elem.setAttribute("class", elem.dataset.desktopClass);
                elem.style.cssText = null;
            });
        });
    }
}